
import {HTMLPrinter} from "../global/htmlprinter";
import {createSiemaSlider, SiemaWithPagination} from "./resource/siema";
import {rightCurry} from "../global/functionalTools";
import {EventListener} from "../global/eventVerteiler";
import {divideIntoArraysOfSize} from "../global/arrayHelper";
import {afterBrowserRepaintDo} from "@k/global/globalUtils";
interface SliderWrapper {
    fillSlider(...args):void;
}

export abstract class AbstractSliderWrapper extends EventListener implements SliderWrapper{
    protected readonly sliderContainer;
    private readonly parentSelector;

    protected slider:SiemaWithPagination|null = null;
    protected abstract getSlides(...contentArray):string[];
    protected abstract initUebersichtListEventHandlers();

    protected constructor(parentSelector) {
        super();
        this.parentSelector = parentSelector;
        this.sliderContainer = $(parentSelector).find(".slider");
    }

    private getSubClassOfParentSelector = (subClass:string)=>[this.parentSelector, HTMLPrinter.classSelector(subClass)].join(" ");
    private getSliderSelector = ()=>this.getSubClassOfParentSelector("slider");
    private getPaginationSelector = ()=>this.getSubClassOfParentSelector("pagination");

    public fillSlider(...args) {
        const slides = this.getSlides(...args);
        this.slider?.destroy();
        this.slider = null;
        this.sliderContainer.empty().html(HTMLPrinter.collection(slides));

        slides.length > 1 ? this.initSlider() : this.hidePagination();
        this.initUebersichtListEventHandlers();
        afterBrowserRepaintDo(()=>this.slider?.resizeHandler());
    }

    protected static getSlidesHTML(zeilen: string[], slideSize) {
        const aufgeteiltInSlideSize = divideIntoArraysOfSize(zeilen, slideSize);
        return aufgeteiltInSlideSize.map(zeilenArray => AbstractSliderWrapper.getSlide(zeilenArray));
    }

    private static getSlide(contentArray) {
        const p = HTMLPrinter;
        return p.divWitHProps(p.cssClass("slide"))(p.collection(...contentArray));
    }


    private static getPaginationArrow = ($paginationElement:JQuery, direction)=>$paginationElement.siblings([".arrow", direction].join("-"));
    private static getPaginationLeftArrow = rightCurry(AbstractSliderWrapper.getPaginationArrow, "left");
    private static getPaginationRightArrow = rightCurry(AbstractSliderWrapper.getPaginationArrow, "right");
    private hidePagination = ()=>$(this.parentSelector).find("footer").css("display", "none");

    private initSlider() {
        this.slider = createSiemaSlider(this.getSliderSelector(), true);
        this.slider.resizeHandler();
        const pagination = $(this.getPaginationSelector());
        $(this.parentSelector).find("footer").css("display", "block");
        this.slider.addPagination(pagination[0]);
        AbstractSliderWrapper.getPaginationLeftArrow(pagination).off().click(()=>(this.slider as SiemaWithPagination).prev());
        AbstractSliderWrapper.getPaginationRightArrow(pagination).off().click(()=>(this.slider as SiemaWithPagination).next());
    }
}
